module.exports = "pegasus/assets/blocks/column-lp13-themelp1.png";